<template>
  <v-container>
    <AvailabilityEdit v-model="measures" @input="close" />
  </v-container>
</template>

<script>
import AvailabilityEdit from "./AvailabilityEdit";

export default {
  components: { AvailabilityEdit },
  props: ["value", "id"],
  data: function() {
    return {
      measures: this.value
    };
  },
  methods: {
    close: async function(value) {
      this.measures = value;
      await fetch(`${process.env.VUE_APP_BACKEND}/shoe/measures/${this.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(this.measures)
      });
      this.$emit("close");
    }
  },
  mounted: function() {
    console.log(this.value);
  }
};
</script>

<style></style>
